import React from 'react';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SlackChannelActionsDefaultChannel = (props: $FIXME) => {
  return (
    <>
      <div className={`current-channel-container`}>
        <Tooltip title="Edit Channel" placement="top" arrow>
          <div
            className={`edit-button ${props.isLoading ? 'disabled' : ''}`}
            onClick={() => props.onEdit?.(props.channel)}
          >
            <FontAwesomeIcon icon="edit" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
        <Tooltip title="Remove Channel" placement="top" arrow>
          <div
            className={`remove-button ${props.isLoading ? 'disabled' : ''}`}
            onClick={() => props.onRemove?.(props.channel)}
          >
            <FontAwesomeIcon icon="trash" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
      </div>
      <style jsx>{`
        .current-channel-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }

        .edit-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }

        .remove-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }

        .disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActionsDefaultChannel;
